import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { IContact } from '../models/contact';
import { ContactService } from '../services/contact.service';

@Injectable({
  providedIn: 'root'
})
export class ContactResolver  {
  
  constructor(private contactService: ContactService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IContact> {
    const id = route.paramMap.get("id");
    return this.contactService.getContact(id);
  }
}
